module.exports = __webpack_public_path__ + "img/samsung.106ee41.png";